module.exports = __webpack_public_path__ + "static/media/monash.139495de.png";